import LoadingSpinner from './LoadingSpinner'

const LoadingTable = ({ text = 'Cargando...', headersCount }) => {
  return (
    <tr>
      <td colSpan={headersCount} className="td-centered">
        <div className="loading-box">
          <LoadingSpinner text={text} />
        </div>
      </td>
    </tr>
  )
}

export default LoadingTable
